var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountRecovery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3777_13302)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#004988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 44.8125V49.8125H42.5V54.8125H37.5V49.8125H34.5C33.5 52.8125 30.75 54.8125 27.5 54.8125C23.25 54.8125 20 51.5625 20 47.3125C20 43.0625 23.25 39.8125 27.5 39.8125C30.75 39.8125 33.5 41.8125 34.5 44.8125H47.5ZM27.5 44.8125C26 44.8125 25 45.8125 25 47.3125C25 48.8125 26 49.8125 27.5 49.8125C29 49.8125 30 48.8125 30 47.3125C30 45.8125 29 44.8125 27.5 44.8125ZM60 54.8125C66.75 54.8125 80 58.0625 80 64.8125V69.8125H40V64.8125C40 58.0625 53.25 54.8125 60 54.8125ZM60 49.8125C54.5 49.8125 50 45.3125 50 39.8125C50 34.3125 54.5 29.8125 60 29.8125C65.5 29.8125 70 34.3125 70 39.8125C70 45.3125 65.5 49.8125 60 49.8125Z",
    fill: "#004988"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3777_13302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountRecovery);
export default __webpack_public_path__ + "static/media/accountRecovery.cf0336befb50aba6d1b9ec1130eaa366.svg";
export { ForwardRef as ReactComponent };